import React from 'react';

export default function ScoreBar({ score, correctCount, elapsedSeconds, gameOver }) {
  const m = String(Math.floor(elapsedSeconds / 60)).padStart(2, '0');
  const s = String(elapsedSeconds % 60).padStart(2, '0');

  return (
    <div className="flex items-center justify-between bg-surface2 border border-border rounded-xl px-4 py-3 mb-2.5">
      <div className="text-center">
        <div className={`font-display text-[26px] tracking-wide leading-none text-accent3 ${gameOver ? '' : 'tabular-nums'}`}>
          {m}:{s}
        </div>
        <div className="font-mono text-[10px] text-dimText tracking-widest uppercase mt-0.5">Time</div>
      </div>

      <div className="w-px h-9 bg-border" />

      <div className="text-center">
        <div className="font-display text-[26px] tracking-wide leading-none text-correct">
          {correctCount}/9
        </div>
        <div className="font-mono text-[10px] text-dimText tracking-widest uppercase mt-0.5">Correct</div>
      </div>

      <div className="w-px h-9 bg-border" />

      <div className="text-center">
        <div className="font-display text-[26px] tracking-wide leading-none text-accent">
          {score.toLocaleString()}
        </div>
        <div className="font-mono text-[10px] text-dimText tracking-widest uppercase mt-0.5">Score</div>
      </div>
    </div>
  );
}
